import { useState } from 'react';
import { NAVY, GOLD } from '../utils/constants';
import { backfillBookingReferences } from '../utils/bookingReference';

export default function Maintenance({ onNavigate }) {
  const [running, setRunning]   = useState(false);
  const [progress, setProgress] = useState(null);
  const [result, setResult]     = useState(null);

  const runBackfill = async () => {
    setRunning(true);
    setResult(null);
    setProgress({ inserted: 0, errors: 0, total: null });
    const r = await backfillBookingReferences((p) => setProgress({ ...p }));
    setResult(r);
    setRunning(false);
  };

  return (
    <div>
      <div className="back-row">
        <button className="back-btn" onClick={() => onNavigate('settings')}>← Settings</button>
      </div>

      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: '1.3rem', fontWeight: 800, color: NAVY, marginBottom: 4 }}>Maintenance</h2>
        <p style={{ fontSize: '0.8rem', color: 'var(--color-ink-muted)' }}>Database utilities and data repair tools</p>
      </div>

      <div style={{
        background: '#fff',
        border: '1px solid var(--color-border)',
        borderRadius: 14,
        padding: '20px 24px',
        boxShadow: '0 1px 6px rgba(10,22,40,0.06)',
      }}>
        <div style={{ fontWeight: 700, fontSize: '0.95rem', color: NAVY, marginBottom: 4 }}>
          Generate Missing References
        </div>
        <div style={{ fontSize: '0.8rem', color: 'var(--color-ink-muted)', marginBottom: 16 }}>
          Scans all bookings and creates booking reference numbers for any that are missing one.
          Safe to run multiple times — only fills gaps.
        </div>

        <button
          onClick={runBackfill}
          disabled={running}
          style={{
            background: running ? '#e8e0d0' : NAVY,
            color: running ? '#8a7a60' : GOLD,
            border: 'none',
            borderRadius: 8,
            padding: '10px 20px',
            fontSize: '0.88rem',
            fontWeight: 700,
            cursor: running ? 'not-allowed' : 'pointer',
          }}
        >
          {running ? 'Running…' : 'Generate Missing References'}
        </button>

        {running && progress && (
          <div style={{ marginTop: 16, fontSize: '0.83rem', color: 'var(--color-ink-secondary)' }}>
            {progress.total != null
              ? `Processed ${progress.inserted + progress.errors} / ${progress.total}…`
              : 'Starting…'}
          </div>
        )}

        {result && !running && (
          <div style={{
            marginTop: 16,
            background: result.errors > 0 ? '#fff8f0' : '#f0fdf4',
            border: `1px solid ${result.errors > 0 ? '#fed7aa' : '#a7f3d0'}`,
            borderRadius: 8,
            padding: '12px 16px',
            fontSize: '0.83rem',
          }}>
            <div style={{ fontWeight: 700, marginBottom: 6, color: result.errors > 0 ? '#c2410c' : '#15803d' }}>
              {result.inserted === 0 && result.errors === 0 ? 'All bookings already have references.' : 'Done!'}
            </div>
            {result.inserted > 0 && <div>✓ {result.inserted} reference{result.inserted !== 1 ? 's' : ''} created</div>}
            {result.skipped > 0  && <div>— {result.skipped} skipped (no cruise code match)</div>}
            {result.errors > 0   && <div style={{ color: '#c2410c' }}>✗ {result.errors} errors (check console)</div>}
          </div>
        )}
      </div>
    </div>
  );
}
